import { IsNotEmpty } from 'class-validator';
import { EpimsBaseEntityDto } from './epim-base.dto';

export class EpimsBankDto extends EpimsBaseEntityDto {
	@IsNotEmpty() BankName: string;

	@IsNotEmpty() BankCode: string;
	length: number;
}
